import { render } from "./SectionArtistFull.vue?vue&type=template&id=0a944bdf&scoped=true"
import script from "./SectionArtistFull.vue?vue&type=script&lang=js"
export * from "./SectionArtistFull.vue?vue&type=script&lang=js"

import "./SectionArtistFull.vue?vue&type=style&index=0&id=0a944bdf&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a944bdf"]])

export default __exports__